import React, { useEffect, useState } from 'react';

import { useMsal } from "@azure/msal-react";
import { useNavigate, useSearchParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { getGAShipItem } from '../../api/auth';
import Header from '../../component/Header';
import Spinner from '../../component/Spinner';

function GAShipItem() {

    const { instance, accounts } = useMsal();
    const activeAccount = instance.getActiveAccount();

    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();

    const [isShow, setIsShow] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [date, setDate] = useState('');
    const [gaShipItem, setGAShipItem] = useState([]);
    useEffect(() => {
        if (!activeAccount) {
            navigate("/mes");
        }
    }, [activeAccount]);

    useEffect(() => {
        setTimeout(async () => {
                try {
                    setIsShow(true);
                    const result = await getGAShipItem(searchParams.get('plant'), searchParams.get('ifkdt'), searchParams.get('seqhd'));
                    console.log('result', result);
                    if (result.ok === true) {
                        setDate(dayjs(result.timestamp).format('M/D/YYYY(ddd)'));
                        setGAShipItem(result.data);
                    } else {
                        alert("API CALL FAIL");
                    }
                } catch (error) {
                    console.log('error', error);
                    alert(error.message);
                } finally {
                    setIsShow(false);
                }
        }, 100);
    }, [refresh]);

    return (
        <>
            <Spinner isShow={isShow} />
            <Header setRefresh={setRefresh} isClose={true} />
            <div className='p-1'>
                <div className='font-bold'>
                    Georgia Shipping Status (Detail)
                </div>
                <div className="relative overflow-x-auto">
                    <table className="w-full text-md text-center rtl:text-right text-gray-500 ">
                        <thead className="text-xs text-gray-700 uppercase bg-slate-300 ">
                            <tr>
                                <th scope="col" className="py-1">
                                    RACK
                                </th>
                                <th scope="col" className="py-1">
                                    MATNR
                                </th>
                                <th scope="col" className="py-1">
                                    MVQTY
                                </th>
                            </tr>
                        </thead>
                        <tbody className="text-black">
                            {
                                gaShipItem?.output?.GASHIPITEM?.map((v, i) => {
                                    return (
                                        <tr key={i} className={`${i % 2 === 0 ? '' : ''} border-b`}>
                                            <td className="py-1">
                                                {v.RACKID}
                                            </td>
                                            <td className="py-1">
                                                {v.MATNR}
                                            </td>
                                            <td className="py-1">
                                                {v.MVQTY}
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}

export default GAShipItem;
